export default {
  state: {
    devedor: {},
    acordo: {}
  },
  mutations: {
    setDevedor (state, payload) {
      state.devedor = payload
    },
    setAcordo (state, payload) {
      state.acordo = payload
    }
  },
  getters: {
    devedor (state) {
      return state.devedor
    },
    acordo (state) {
      return state.acordo
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/devedor/index.js